import { combineReducers } from 'redux'

import resultados from './detalhesAtaRegistroPreco'
import itemAta from './itemAta'
import destinosItem from './destinosItem'
import detalhesFornecedoresItem from './detalhesFornecedoresItem'
import empenhosAta from './empenhosAta'
import contratoAta from './contratoAta'

export default combineReducers({ resultados, itemAta, detalhesFornecedoresItem, destinosItem, empenhosAta, contratoAta })
